import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GameSettingsPanel from '../components/GameSelector';
import { getCategories } from '../utils/api';

const TimeTrialSettings = () => {
  const navigate = useNavigate();
  const [modeOptions, setModeOptions] = useState([]);

  const handleOnStart = (settings) => {
    console.log('Starting Time Trial with settings:', settings);
    navigate('/time-trial', { state: { settings } });
  }
  useEffect(() => {
    const fetchCats = async () => {
      try {
        const data = await getCategories();
        setModeOptions([
          { label: 'Schedule', value: 'schedule' },
          { label: 'Priority', value: 'priority' },
          { label: 'No category', value: 'uncategorized' },
          ...(data.categories || []).map((category) => ({
            label: category.name,
            value: `category:${category.id}`,
            color: category.color,
          })),
        ]);
      } catch (err) {
        console.error('Failed to fetch categories:', err);
      }
    };
    fetchCats();
  }, []);

  const timeOptions = Array.from({ length: 12 }, (_, i) => {
    const minutes = 5 * (i + 1);
    return { label: `${minutes} min`, value: minutes };
  });

  const settings = [
    {
      key: 'mode',
      label: 'Mode',
      options: modeOptions
    },
    {
      key: 'time',
      label: 'Time',
      options: timeOptions
    }
  ];

  return (
    <div id="time-trial-settings-page">
      {modeOptions.length > 0 ? (
        <GameSettingsPanel
          idPrefix="time-trial-settings"
          title="Time Trial"
          settings={settings}
          initialValues={{ time: 5 }}
          OnStart={handleOnStart}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default TimeTrialSettings;
